import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight, ImageOff, Check, X } from "lucide-react";
import { gradeFromScore, relTime } from "@/lib/rating";
import { useI18n } from "@/i18n/I18nContext";
import { resolveImage } from "@/lib/api";

export const ListCard = ({ item, time, onClick, right }) => {
  const g = gradeFromScore(item.score_total);
  const { t } = useI18n();
  const [err, setErr] = useState(false);
  const img = resolveImage(item.image_url);
  const nav = useNavigate();
  return (
    <button data-testid={`list-card-${item.barcode}`}
      onClick={onClick || (() => nav(`/product/${item.barcode}`))}
      className="w-full flex items-center gap-3 py-3 border-b border-slate-100 text-left active:bg-slate-50 transition-colors">
      <div className="w-14 h-14 rounded-xl bg-slate-100 overflow-hidden flex items-center justify-center shrink-0">
        {img && !err ? <img src={img} alt="" loading="lazy" decoding="async" onError={() => setErr(true)} className="w-full h-full object-contain p-1" />
          : <ImageOff className="w-6 h-6 text-slate-300" />}
      </div>
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-slate-900 truncate">{item.name}</p>
        <p className="text-sm text-slate-400 truncate">{item.brand || "—"}</p>
        <div className="flex items-center gap-1.5 mt-1">
          <span className="w-2.5 h-2.5 rounded-full" style={{ background: g.solid }} />
          <span className="text-sm font-medium" style={{ color: g.text }}>{t(`grade.${g.key}`)}</span>
        </div>
      </div>
      {right ? right : (time && <span className="text-xs text-slate-400 self-start mt-1 shrink-0">{relTime(time, t)}</span>)}
      <ChevronRight className="w-5 h-5 text-slate-300 shrink-0" />
    </button>
  );
};

export const GridCard = ({ item, badge }) => {
  const g = gradeFromScore(item.score_total);
  const { t } = useI18n();
  const [err, setErr] = useState(false);
  const img = resolveImage(item.image_url);
  const nav = useNavigate();
  return (
    <button data-testid={`grid-card-${item.barcode}`} onClick={() => nav(`/product/${item.barcode}`)}
      className="relative bg-[#FBF8F2] rounded-2xl border border-black/5 p-3 text-left shadow-[0_2px_8px_rgba(60,50,35,0.06)] active:scale-[0.98] transition-transform">
      {badge && (
        <span className={`absolute -top-2 -left-2 w-7 h-7 rounded-full flex items-center justify-center text-white shadow-md ${badge === "good" ? "bg-emerald-500" : "bg-red-500"}`}>
          {badge === "good" ? <Check className="w-4 h-4" strokeWidth={3} /> : <X className="w-4 h-4" strokeWidth={3} />}
        </span>
      )}
      <div className="aspect-square rounded-xl bg-slate-50 overflow-hidden flex items-center justify-center mb-2">
        {img && !err ? <img src={img} alt="" loading="lazy" decoding="async" onError={() => setErr(true)} className="w-full h-full object-contain p-2" />
          : <ImageOff className="w-8 h-8 text-slate-300" />}
      </div>
      <p className="font-semibold text-sm text-slate-900 truncate">{item.name}</p>
      <p className="text-xs text-slate-400 truncate">{item.brand || "—"}</p>
      <div className="flex items-center gap-1.5 mt-1">
        <span className="w-2 h-2 rounded-full" style={{ background: g.solid }} />
        <span className="text-xs font-medium" style={{ color: g.text }}>{t(`grade.${g.key}`)}</span>
      </div>
    </button>
  );
};
